// バックエンドからのJSONは要素1の配列は単一オブジェクトとして来る.I/Oを揃えられるよう共通の変換を実装.
export class ArrayComplexTranslator {
  from<T>(source: T | T[]): T[] {
    return Array.isArray(source)
      ? source
      : (source ? [ source ] : []);
  }

  to<T>(source: T[]): T | T[] {
    return (source && (0 < source.length))
      ? ((1 < source.length) ? source : source[0])
      : undefined;
  }
}
